var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChinagongsang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2225_5245)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12405 14.3241C2.13318 16.7252 2.85293 19.0698 4.19259 21.0624C5.53225 23.055 7.43183 24.6065 9.65189 25.5211C11.8719 26.4358 14.3131 26.6726 16.6676 26.2019C19.0221 25.7313 21.1845 24.5741 22.8824 22.8763C24.5802 21.1785 25.7374 19.016 26.2081 16.6615C26.6787 14.307 26.4418 11.8659 25.5272 9.64583C24.6125 7.42577 23.0611 5.52616 21.0685 4.1865C19.0759 2.84684 16.7312 2.12709 14.3302 2.11796C12.7264 2.11491 11.1378 2.42858 9.65548 3.04092C8.17318 3.65326 6.82638 4.55222 5.69233 5.68627C4.55827 6.82033 3.65928 8.16713 3.04694 9.64942C2.4346 11.1317 2.12101 12.7203 2.12405 14.3241ZM0.000198499 14.3241C0.000198499 11.4899 0.840616 8.71936 2.41522 6.3628C3.98982 4.00624 6.2279 2.16955 8.84636 1.08495C11.4648 0.000347083 14.3461 -0.283431 17.1258 0.269495C19.9056 0.822421 22.4589 2.18721 24.463 4.19129C26.4671 6.19538 27.8319 8.74878 28.3848 11.5285C28.9378 14.3083 28.654 17.1895 27.5694 19.808C26.4848 22.4265 24.648 24.6645 22.2915 26.2391C19.9349 27.8137 17.1644 28.6542 14.3302 28.6542C12.4455 28.6641 10.5777 28.3002 8.8346 27.5836C7.09151 26.867 5.50784 25.8118 4.17519 24.4792C2.84254 23.1465 1.78738 21.5628 1.07075 19.8198C0.354126 18.0767 -0.00974695 16.2087 0.000198499 14.3241Z",
    fill: "#D7001D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56152 15.6401H10.9996V13.4182H6.56152V6.86206H13.5216V8.882H8.57569V11.3001H13.0195V17.6601H8.57569V20.0782H13.5216V22.0981H6.56152V15.6401Z",
    fill: "#D7001D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7984 15.6401H17.2564V13.4182H21.7984V6.86206H14.7344V8.882H19.7784V11.3001H15.2365V17.6601H19.7784V20.0782H14.7344V22.0981H21.7984V15.6401Z",
    fill: "#D7001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2225_5245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.66,
    height: 28.66,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinagongsang);
export default __webpack_public_path__ + "static/media/chinagongsang.d05cf35f1dd751b199beb3312dad36d9.svg";
export { ForwardRef as ReactComponent };